import { Route } from '@angular/router';

export const FinanciersRoute: Route = {
  path: 'financiers',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/financiers_shell'
    ).then((c) => c.financiersShellRoutes);
  },
};
